import "@/styles/globals.css";
import type { AppProps } from "next/app";
import { useEffect } from "react";
import { useRouter } from "next/router";
import AOS from "aos";
import "aos/dist/aos.css";
import Script from "next/script";

export default function App({ Component, pageProps }: AppProps) {
  const router = useRouter();

  useEffect(() => {
    AOS.init({ duration: 600, once: true });

    const handleRouteChange = () => {
      AOS.refreshHard(); // safer than AOS.refresh()
    };
    
    router.events.on("routeChangeComplete", handleRouteChange);
    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, [router.events]);

  return (
    <>
      {/* ✅ Vendor JS Libraries (must load before main.js) */}
      <Script src="/assets/vendor/aos/aos.js" strategy="beforeInteractive" />
      <Script src="/assets/vendor/swiper/swiper-bundle.min.js" strategy="beforeInteractive" />
      <Script src="/assets/vendor/glightbox/js/glightbox.min.js" strategy="beforeInteractive" />
      <Script src="/assets/vendor/imagesloaded/imagesloaded.pkgd.min.js" strategy="beforeInteractive" />
      <Script src="/assets/vendor/isotope-layout/isotope.pkgd.min.js" strategy="beforeInteractive" />
      <Script src="/assets/vendor/purecounter/purecounter_vanilla.js" strategy="beforeInteractive" />

      {/* ✅ Main Custom Script (must load last) */}
      <Script src="/assets/js/main.js" strategy="afterInteractive" />

      {/* ✅ Your app content */}
      <Component {...pageProps} />
    </>
  );
}
